@import '../../global/accessibility.css';

nj-reduction-cards {
  /* Component styles go here */
  box-sizing: border-box;

  display: block;
  color: #000;
  font-size: 16px;
}
nj-reduction-cards * {
  /* Component styles go here */
  box-sizing: border-box;
}

nj-reduction-cards h3 {
    margin: 0 0 0;
    font-size: 16px;
}

nj-reduction-cards .reduction-cards {
    list-style-type: none;
    padding: 0;
    margin: 10px 0 0 ;
}

nj-reduction-cards .selected-cards {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  border: none;
}

nj-reduction-cards li {
    /* Component styles go here */
    position: relative;
    list-style-type: none;
    padding: 0;
    margin: 0;
    border: none;
}

nj-reduction-cards li button {
    overflow: hidden;
    display: block;
    position: relative;
    width: 100%;
    text-decoration: none;
    border: none;
    background: white;
    text-align: left;
    font-size: 1em;
    margin: 0;
    padding: 0;
}

nj-reduction-cards .reduction-card {
    border-bottom: 1px solid #666666;
    padding: 0;
    margin-bottom: 10px;
}



nj-reduction-cards li button.reduction-card__country {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 10px 0;
}

nj-reduction-cards .reduction-card__flag {
    margin-right: 10px;
}



nj-reduction-cards li check-icon {
  position: absolute;
  right: 10px;
  top: 10px;
}

nj-reduction-cards .reduction-card-group {
    display: none;
    padding: 0 0 0 10px;
}

nj-reduction-cards .reduction-card--open .reduction-card-group {
    display: block;
}

nj-reduction-cards .reduction-card--open .icon-toggler {
    transform: rotate(180deg);
}

nj-reduction-cards .reduction-card-group__card {
    border-bottom: 1px solid #666;
}

nj-reduction-cards .reduction-card-group__card:last-child {
    border-bottom: none;
}

nj-reduction-cards .reduction-card-group__card-button {
    display: flex;
    padding: 10px 0;
    width: 100%;
    cursor: pointer;
}

nj-reduction-cards .card-icon {
    margin-right: 10px;
}



.nj-input {
  display: inline-block;
  position: relative;
  width: 210px;
  min-height: 27.5px;
  margin: 16px 0 2px;
  padding: 8px 5px 7.5px 7.5px;
  border-radius: 1px;
  border: solid 0.5px #222;
  background-color: #fff;
}
.nj-input label {
  display: inline-block;
  position: absolute;
  top: -10px;
  background: #fff;
}
.nj-input label {
  display: inline-block;
  position: absolute;
  top: -10px;
  background: #fff;
  padding: 0 4px;
}
.nj-input input,
.nj-input input:focus,
.nj-input input:active {
  border: none;
  outline: 0;
  background: transparent;
  width: 100%;
  font-size: 16px;
  padding: 4px;
  padding-right: 35px;
}
.nj-input:focus-within {
  background: #fbfbfb;
  color: #000;
}
.nj-input-block {
  display: block;
  width: auto;
}

.selected-cards__filter .nj-input:focus-within {
  outline: 1px solid #000;
  outline-offset: -2px;
}

.close-btn {
  position: absolute;
  right: 0;
  padding: 10px 10px 10px 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  color:#aaa;
  fill: currentColor;
  top:50%;
  transform: translateY(-50%);
}
.close-btn:hover{
    color:#666;
    fill: currentColor;
}


